import axios from "axios";
import { path } from "../path";
import store from "../store/index"
import { v4 as uuid } from 'uuid'

export const EventTypes = {
  DOWNLOAD_CLICK: "download_click",
  CONTEST_OPEN: "contest_open",
  SECTION_CLICK: "section_click",
  JUDGE_VISIT: "judge_visit",
  PAGE_VIEW: "page_view",
  REGISTER_CLICK: "register_click",
  UPLOAD_SPEED: "upload_speed",
  APPLY_AS_JUDGE_ACHIEVEMENT: "apply_as_judge_achievement",
  APPLY_AS_JUDGE_COMPLETE: "apply_as_judge_complete"
};

// Utility function to track web-events
export const trackEvent = async (type, data = {}) => {
  try {
    const user = store.getState().AuthReducer.user;
    if (!type) {
      throw new Error("event-type not defined");
    }

    let uniqueId = localStorage.getItem("uniqueId");
    if (!uniqueId) {
      uniqueId = uuid();
      localStorage.setItem('unique_device_id', uniqueId);
    }
    console.log("user");
    console.log(user);
    const body = {
      type,
      data,
      uniqueId, 
    }

    if(user && user._id) {
      body["userId"] = user._id;
    }

    await axios.post(`${path}/analytics/track-web-events`, body);
  } catch (error) {
    console.error("Error in tracking the event:", error);
  }
};

export const logAuthError = async (payload) => {
  try {
    let uniqueId = localStorage.getItem('unique_device_id')
    if (!uniqueId) {
      uniqueId = uuid();
      localStorage.setItem('unique_device_id', uniqueId);
    }
    await axios.post(`${path}/logAuthError`, {
      ...payload,
      uniqueId,
      medium: `WebApp ${navigator.userAgent}`
    })
  } catch (error) {
    console.error("Error in logAuthError: "+JSON.stringify(error));
  }
}
